export const userModel = {
  email: "",
  password: "",
  firstName: "",
  lastName: ""
};
